// @ts-expect-error Untyped module
import SafeStorage from 'SafeStorage';
export default class LocalStorage {
  static getAttribute(key) {
    try {
      return SafeStorage.getItem(key);
    } catch (err) {
      return undefined;
    }
  }
  static getAttributeParsed(key) {
    const value = LocalStorage.getAttribute(key);
    if (value) {
      try {
        return JSON.parse(value);
      } catch (err) {
        return undefined;
      }
    }
    return undefined;
  }
  static setAttribute(key, value) {
    try {
      SafeStorage.setItem(key, value);
    } catch (err) {
      return;
    }
  }
  static removeAttribute(key) {
    try {
      SafeStorage.removeItem(key);
    } catch (err) {
      return;
    }
  }
}